module.exports = __webpack_public_path__ + "offline.html?58cd9c7036c59bd18b9249ac073f4ee2";


//////////////////
// WEBPACK FOOTER
// ./client/static/offline.html
// module id = 277
// module chunks = 0